import styles from './MorePage.module.scss';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory, useLocation } from 'react-router-dom';
import LoadingIndicator from '../components/loading-indicator/LoadingIndicator';
import MainNav from '../components/main-nav/MainNav';
import hdrlogo from 'assets/images/hrd-logo.png';
import profileImg from 'assets/images/profile.svg';
import beneficiaris from 'assets/images/beneficiaris.svg';
import calculator from 'assets/images/calculator.svg';
import about from 'assets/images/about.svg';
import contact from 'assets/images/contact.svg';
import unlock from 'assets/images/unlock.svg';
import remittance from 'assets/images/remittance.svg';
import toggle from 'assets/images/toggle.svg';
import device from 'assets/images/device.svg';
import logout from 'assets/images/logout.svg';
import twitter from 'assets/images/twitter.svg';
import facebook from 'assets/images/facebook.svg';
import instagram from 'assets/images/instagram.svg';
import linkedin from 'assets/images/linkedin.svg';
import location from 'assets/images/location-black.svg';
import profilePic from 'assets/images/profilePic.png';
import { Profile } from '../components/profile/Profile';
import { commonActions, ratesActions } from '../../stores/_actions';
import popClose from 'assets/images/pop-close.svg';
import Label from '../../constants/Label';
import { CancelRemittance } from '../my-transfer-page/components/CancelRemittance';

function MorePage() {
  const profile = JSON.parse(localStorage.getItem('userProfile'));
  const sessionId = JSON.parse(localStorage.getItem('SessionId'));
  const payload = {
    Id: null,
    Message: null,
    CustomerCode: null,
    Data: {
      CustomerCode: profile?.CustomerCode,
    },
    Status: false,
    SessionID: sessionId,
    IdType: null,
  };
  let userProfile = useSelector((state) => state.getCustDetails.data);
  const dispatch = useDispatch();
  useEffect(() => {
    userProfile = userProfile == undefined ? dispatch(commonActions.getCustDetailsByCode(payload)) : '';
    dispatch(ratesActions.clearRatesData());
  }, []);
  const history = useHistory();

  const logoutPage = () => {
    localStorage.clear();
    history.push('/');
  };

  const [popShow, openPopUp] = useState(false);
  const cancelRemit = () => {
    openPopUp(true);
  };

  const closePopUp = () => openPopUp(!popShow);

  return (
    <LoadingIndicator>
      <div className={styles.mainContainer}>
        <MainNav />
        <div className={styles.mainContainer__contentPart}>
          <div className={styles.mainContainer__profileBar}>
            <img src={hdrlogo} />
          </div>
          <div className={styles.mainContainer__pageCont}>
            <div className={styles.pageLeft}>
              <div className={styles.pageLeft__profileLinks}>
                <Link to="/myprofile">
                  <img src={profileImg} alt="" />
                  My Profile
                </Link>
                <Link to="/beneficiaries">
                  <img src={beneficiaris} alt="" />
                  My Beneficiaries
                </Link>
                <Link to="/calculator">
                  <img src={calculator} alt="" />
                  Currency Calculator
                </Link>
                <Link to="/about">
                  <img src={about} alt="" />
                  About
                </Link>
                <Link to="/contact">
                  <img src={contact} alt="" />
                  Contact
                </Link>
                {/* <Link to="/forgot-password">
                  <img src={unlock} alt="" />
                  Forgot Password
                </Link> */}
                <Link to="/change-password">
                  <img src={unlock} alt="" />
                  Change Transaction Password
                </Link>
              </div>
              <div className={styles.pageLeft__cancelRem}>
                <Link onClick={cancelRemit}>
                  <img src={remittance} alt="" />
                  Cancel Remittance
                </Link>
                {/* <Link to="/news-events">
                  <img src={toggle} alt="" />
                  Fingerprint
                </Link>
                <span>&nbsp;</span>
              </div>
              <div className={styles.pageLeft__cancelRem + ' ' + styles.notopbdr}>
                <Link to="/news-events">
                  <img src={device} alt="" />
                  Unregister Device
                </Link> */}
                {/* <Link onClick={logoutPage}>
                  <img src={logout} alt="" />
                  Logout
                </Link>
                <span>&nbsp;</span> */}
              </div>

              {/* <div className={styles.pageLeft__sociallinks}>
                <Link to="/news-events">
                  <img src={twitter} alt="" />
                  Twitter
                </Link>
                <Link to="/news-events">
                  <img src={facebook} alt="" />
                  Facebook
                </Link>
                <Link to="/news-events">
                  <img src={instagram} alt="" />
                  Instagram
                </Link>
                <Link to="/news-events">
                  <img src={linkedin} alt="" />
                  Linkedin
                </Link>
              </div> */}
            </div>
            <Profile userProfile={userProfile} />
            {popShow ? (
              <div className={styles.dialogue}>
                <div className={styles.dialogue__wrap}>
                  <img className={styles.dialogue__close} src={popClose} onClick={closePopUp} />
                  <CancelRemittance />
                  {/* <div className={styles.dialogue__buttons}>
                    <input type="submit" value={Label.VerifyOtp.buttonOkLabel} onClick={!popShow} className={styles.LoginPage__link} />
                    <input type="submit" value={Label.VerifyOtp.buttonCancelLabel} onClick={!popShow} className={styles.LoginPage__link} />
                  </div> */}
                </div>
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
      </div>
    </LoadingIndicator>
  );
}

export { MorePage };
